/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Buffer } from 'buffer';

import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const ThumbnailUserGet = {
  id: 'thumbnail-user.get',
  tag: 'Common',
  summary: 'Generate thumbnail for user',
  description: 'Generate thumbnail for user',
  flags: { isAuthorized: true },
  method: 'get',
  route: () => `/thumbnail/user`,
  request: {
    query: z.strictObject({ seed: ZodTypes.Base64, size: z.coerce.number().int().min(1).max(256).optional() }),
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.instanceof(Buffer),
        },
      },
    },
  },
} as const satisfies Endpoint;
